_ = require 'underscore'

module.exports = class SchedulingMixin
  setTimeout: (fn, interval) ->
    @_scheduled_timeouts ?= []
    @_scheduled_timeouts.push(idTimeout = setTimeout(fn, interval))
    idTimeout

  setInterval: (fn, interval) ->
    @_scheduled_intervals ?= []
    @_scheduled_intervals.push(idInterval = setInterval(fn, interval))
    return idInterval

  requestAnimationFrame: (fn) ->
    @_scheduled_frameRequests ?= []
    @_scheduled_frameRequests.push(idRequest = requestAnimationFrame(fn))
    idRequest

  callback: (fn) ->
    callbacks = @_scheduled_callbacks ?= []
    @_scheduled_callbacks.push(fn)
    # A version of the callback that only runs if cancelScheduled hasn't
    # been called
    (args...) ->
      index = callbacks.indexOf(fn)
      if index != -1
        callbacks.splice(index, 1)
        return fn.apply(@, args)
      else
        return

  cancelScheduled: ->
    if @_scheduled_callbacks?
      while @_scheduled_callbacks.length
        @_scheduled_callbacks.pop()

    if @_scheduled_intervals?
      for interval in @_scheduled_intervals
        clearInterval interval

    if @_scheduled_timeouts?
      for timeout in @_scheduled_timeouts
        clearTimeout timeout

    if @_scheduled_frameRequests?
      for frameRequest in @_scheduled_frameRequests ? []
        cancelAnimationFrame frameRequest

    return

  defer: (fn) ->
    @setTimeout fn, 1

  debounce: (fn, wait = 1) ->
    @dynamicDebounce(fn, -> wait)

  dynamicDebounce: (fn, getInterval) ->
    setTimeout = @setTimeout.bind(@)
    timeout = null
    return ->
      args = arguments
      later = =>
        timeout = null
        fn.apply(@, args)
        return
      clearTimeout(timeout)
      timeout = setTimeout(later, getInterval.apply(@, args))
      return

  throttle: (func, wait, options = {}) ->
    context = args = result = timeout = null
    leading = options.leading ? true
    trailing = options.trailing ? true

    setTimeout = @setTimeout.bind(@)
    previous = null
    later = ->
      previous = if leading then _.now() else 0
      timeout = null
      result = func.apply(context, args)
      context = args = null
    return ->
      now = _.now()
      if !previous? && !leading
        previous = now

      remaining = wait - (now - previous)
      context = this
      args = arguments
      if remaining <= 0
        clearTimeout timeout
        timeout = null
        previous = now
        result = func.apply(context, args)
        context = args = null
      else if !timeout && trailing
        timeout = setTimeout later, remaining
      return result



// WEBPACK FOOTER //
// ./app/scripts/lib/scheduling-mixin.coffee